import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesLinktypesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-linktypes-edit',
	path: '/secure/admin/EditLinkType!default.jspa',
};
